import { render } from "./ApproveUsers.vue?vue&type=template&id=70290070"
import script from "./ApproveUsers.vue?vue&type=script&lang=js"
export * from "./ApproveUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__